export interface CalendarServiceState {
    connectPlusGatewayStatus: boolean;
}

export const initialCalendarServiceState: CalendarServiceState = {
    connectPlusGatewayStatus: false,
};
